var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidenavMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8244 19.7911C22.1537 19.7911 15.9354 25.1321 15.9354 31.7207V68.427C15.9354 75.0156 22.1537 80.3566 29.8244 80.3566H72.5592C80.23 80.3566 86.4482 75.0156 86.4482 68.427V31.7207C86.4482 25.1321 80.23 19.7911 72.5592 19.7911H29.8244ZM9.52515 31.7207C9.52515 22.0913 18.6134 14.2852 29.8244 14.2852H72.5592C83.7703 14.2852 92.8585 22.0913 92.8585 31.7207V68.427C92.8585 78.0564 83.7703 85.8625 72.5592 85.8625H29.8244C18.6134 85.8625 9.52515 78.0564 9.52515 68.427V31.7207Z",
    fill: "#4A6375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.193 53.7851L14.1649 37.8828L11.2981 42.8076L49.7597 59.3254C50.662 59.7128 51.724 59.7128 52.6263 59.3254L91.0879 42.8076L88.2212 37.8828L51.193 53.7851Z",
    fill: "#4A6375"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavMessage);
export default __webpack_public_path__ + "static/media/sidenav_message.bb51a8103d5a1fe8d4a937d8cd8c922c.svg";
export { ForwardRef as ReactComponent };